module.exports = __webpack_public_path__ + "img/icn_star_active.0bf0bebc.svg";